import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';
import { observer } from 'mobx-react-lite';

interface ClaimDiscountBottomSheetProps {}

const GoldClassCouponBottomSheet: FC<ClaimDiscountBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <NolNoticeBottomSheet
      title={'Gold Class 등급 전용 혜택 유의사항'}
      isOpen={store.isGoldClassCouponBottomSheetOpen}
      onRequestClose={() => (store.isGoldClassCouponBottomSheetOpen = false)}
    >
      <ul>
        <li>NOL 포인트 10% 기본 적립 혜택과 중복 제공</li>
        <li>
          타 쿠폰 및 즉시할인, 포인트와 중복 사용 가능(단, 할인쿠폰 및 즉시할인, 포인트 사용 후 최종 카드 결제 금액이
          누적 결제 조건 금액 충족 시 혜택 제공)
        </li>
        <li>포인트 제공 일정은 NOL 및 현대카드 또는 회원 사정에 따라 변경될 수 있음</li>
        <li>카드 승인 후 취소, 부분취소, 반품, 품절, 환불 등으로 결제 금액 미달 시 혜택 제공 불가</li>
        <li>
          혜택 제공 시점에 대상 카드 해지, 분실, 교체(재발급 등), 정지(연체 등) 등의 경우 혜택 제공 불가(카드 상태가
          정상인 경우에 한해 제공)
        </li>
        <li>모든 가맹점은 현대카드 가맹점등록 및 업종 분류 기준이며, 가맹점명이 NOL인경우에만 혜택이 적용 됨</li>
        <li>
          Gold Class 등급 선정 및 혜택 관련 문의는 NOL 고객센터(1644-1346)로, 이외 해당 이벤트 관련 자세한 내용은
          현대카드 고객센터(1577-6000)로 문의
        </li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(GoldClassCouponBottomSheet);
